import { Injectable, inject } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { UserService } from "../services/user.service";
import { Claims } from "../constants";

@Injectable({ providedIn: "root" })
export class AdminGuard  {
  private _userService = inject(UserService);


  canActivate(
    _route: ActivatedRouteSnapshot, 
    _state: RouterStateSnapshot
  ) {
    return (
      this._userService.CurrentUser &&
      this._userService.HasClaim(Claims.Administration_IstAdmin)
    );
  }
}
